import React from 'react'

export default function PaymentMethod() {
  return (
    <div>
      method
    </div>
  )
}
